// generated from 54_406 samples

import { z } from "zod";
import { conversionGetBaseSchema } from "./conversionGetBaseSchema";
import { conversionFiltersGetSchema } from "./conversionFiltersGetSchema";

export const purchasedProductConversionGetSchema = z.object({
  ...conversionGetBaseSchema.shape,
  event_type: z.literal("TrackedUserBehavior::PurchasedProduct"),
  blocklisted: z.null(),
  filter_description: z.string().optional(),
  filters: conversionFiltersGetSchema.optional(),
  hard_deleted: z.null(),
  product_name: z.string(),
});
